import dayjs from 'dayjs'

const filter = {
  upcoming(input){
    let output = []

    if(input && input.length > 0){
      for (let index = 0; index < input.length; index++) {
        const element = input[index];
        const { date_start } = element
        const isAfter = dayjs(date_start).isAfter(new Date())

        if(isAfter){
          output.push(element)
        }
      }
    }

    return output
  }
}

export default filter
